import { useDeleteArea } from "./api/deleteArea";
import { Button } from "reactstrap";


const DeleteArea = ({handleCloseModal, areaId}: DeleteAreaProps)  => {
  
  const deleteAreaMutation = useDeleteArea({ areaId});
  const handleSubmit = async (): Promise<void> => {
    deleteAreaMutation.mutateAsync({ 
      areaId: areaId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε την Περιοχή;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteAreaProps{
  areaId: number;
  handleCloseModal: () => void;
}

export default DeleteArea;